//** Component  */
import React from "react";

//** Lib */
import SecurityPermission from "./SecurityPermission";
import ModulePermission from "../modulePermission/ModulePermission";
import RequestOperationalModuleListTab from "../../styles/RequestOperationalModuleListTab";

const data = [
  {
    id: "1",
    tabTitle: "Module Permission",
    tabContent: <SecurityPermission/>,
  },
  {
    id: "2",
    tabTitle: "Security Permission",
    tabContent: <ModulePermission/>,
  },
];
function PermissionList() {
  const [visibleTab, setVisibleTab] = React.useState(data[0].id);

  const listTitles = data.map((item) => (
    <li
      onClick={() => setVisibleTab(item.id)}
      className={
        visibleTab === item.id
        ?"tab-title tab-title--active  btn-hover-1 color-3 active pl-3"
        : "btn-hover-1 color-3 tab-title pl-3"
      }
    >
      {item.tabTitle}
    </li>
  ));

  const listContent = data.map((item) =>
    visibleTab === item.id ? <p style={{}}>{item.tabContent}</p> : null
  );
  return (
    <>
      <RequestOperationalModuleListTab/>
      <div>
        <div className="tabs new-btn-width scroll_content_logs">
          <ul className="tabs-titles justify-content-left new-border pl-0">
            {listTitles}
          </ul>
          <div className="tab-content mt-2">{listContent}</div>
        </div>
      </div>
    </>
  );
}

export default PermissionList;
